import { ICopyValidationState } from '../model/types'

interface IInitiativeWithEntryId {
  EntryId: number
}

export const hasInvalidSelectedInitiatives = <T extends IInitiativeWithEntryId>(
  selectedInitiatives: T[],
  validation: Record<number, ICopyValidationState>
): boolean =>
  selectedInitiatives.some((initiative) => validation[initiative.EntryId]?.status === 'invalid')
